/**
 * 接口管理文件
 */

// 客服
const KFDomain = 'http://kefu.weidian.com';

const PCClientTrs = '//wd.api.weidian.com';
const STAFF_SERVICE = 'http://kefu.weidian.com/EliteWebChat/jsp/standard/customer.jsp';

// 获取地址
const getTicketUrlDev = 'https://gw.test.weidian.com/h5/wd/im/robot/getTicket';
const getTicketUrl = 'https://gwh5.api.weidian.com/wd/im/robot/getTicket';

// 基础请求地址
const BaseUrl = 'https://im-pivot.api.weidian.com';
// const BaseUrl = 'http://im-pivot-old.pre.weidian.com';

export {
  KFDomain,
  PCClientTrs,
  BaseUrl,
  STAFF_SERVICE,
  getTicketUrlDev,
  getTicketUrl
};



/** WEBPACK FOOTER **
 ** ./lib/request.urls.js
 **/